import type { SwitchProps as _SwitchProps } from "@chakra-ui/react";
import { forwardRef, Switch as _Switch } from "@chakra-ui/react";

export interface SwitchProps extends _SwitchProps {}

export const Switch = forwardRef<SwitchProps, "switch">(({ ...props }, ref) => (
    <_Switch ref={ref} {...props} />
));
